import React from "react";
import CAFLogin from "./CAFLogin";

export const SignInPage = () => {
  return <CAFLogin auth_page="auth-page" />;
};
